// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Connection List component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var EventUtils = require('EventUtils');

  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var List = require('share/components/controls/Izenda.List');
  var ConnectionItem = require('./Izenda.ConnectionItem');
  var compare = require('share/utils/Izenda.PropsComparison');

  var notifyChange = EventUtils.notifyChange;
  var notify = EventUtils.notify;

  var ConnectionList = React.createClass({
    propTypes: {
      isMiddlePanelMinimum: React.PropTypes.bool,
      store: React.PropTypes.object.isRequired
    },
    getDefaultProps : function () {
      return {
        isMiddlePanelMinimum : false
      }
    },

    componentDidMount: function() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.loadList().finally(loader.endLoading.bind(loader));
    },

    shouldComponentUpdate: function(nextProps){
      return !compare(nextProps, this.props);
    },

    render: function () {
      return (
        <div className="izenda-ConnectionList u_fullHeight u-posRelative u-bgWhite">
          {this.getRenderHeaderContent()}
          {this.getRenderListConnection()}
      </div>
      );
    },

    getRenderHeaderContent: function () {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;

      return (
        <div className="izenda-MiddlePanel-search">
          <a
            className="u_block overflow-text"
            onClick={this.addNewConnection}
            title={localization.getText("CONNECTION_LABEL_ADD_CONNECTION")}>
            <span className="icon-plus">
            </span>
            {localization.getText("CONNECTION_LABEL_ADD_CONNECTION")}
          </a>
          <div className="search-box">
            <SearchTextBox value={store.filter}
              onChange={notifyChange(store.setFilter.bind(store), EventUtils.INPUT)}
              onKeyPress={this.selectSearchedConnection}/>
          </div>
          <hr />
        </div>
      );
    },

    getRenderListConnection: function () {
      var isMiddlePanelMinimum = this.props.isMiddlePanelMinimum;
      var store = this.props.store;

      return (
        <div className="izenda-ConnectionList-content izenda-MiddlePanel-content">
          <ScrollBox>
            <List itemClass="connection-string-item">
              {store.filteredConnections.map(function (item, idx){
                return (
                  <ConnectionItem
                    key={idx}
                    dataSource={item}
                    store={store}
                    isMiddlePanelMinimum={isMiddlePanelMinimum}>
                  </ConnectionItem>
                );
              })}
            </List>
          </ScrollBox>
        </div>
      );
    },

    /**
     * When there is only one item in searched connection list, user can press enter
     * to select it.
     * @param  {Object} event React-event
     */
    selectSearchedConnection: function (event){
      if(event.key === 'Enter'){
        var store = this.props.store;
        if(store.filteredConnections.length === 1){
          store.item = store.filteredConnections[0];
        }
      }
    },

    /**
     * Add a new connection. New connection detail is showed.
     */
    addNewConnection: function (){
      this.props.store.filter = '';
      this.props.store.addConnection();
    }
  });

  module.exports = connect()(ConnectionList);
}())



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionList/Izenda.ConnectionList.jsx